const config = {
  api_key: '3183D14A32F1FE92660C54707CDCBDC8'
}
export default config
